/**
 * VulForm Astro Integration
 * Provides seamless integration with Astro projects
 */

import { resolveApiUrl } from '@vulform/core';

// Note: AstroIntegration type may not be available during build
// Using any for now to avoid compilation issues
type AstroIntegration = any;

export interface VulFormIntegrationOptions {
  apiKey?: string;
  apiUrl?: string;
  debug?: boolean;
}

export function VulFormIntegration(options: VulFormIntegrationOptions = {}): AstroIntegration {
  return {
    name: 'vulform',
    hooks: {
      'astro:config:setup': ({ injectScript }: any) => {
        // Resolve API URL using the new configuration system
        const resolvedApiUrl = resolveApiUrl(options.apiUrl, 'auto');

        // Inject global VulForm configuration
        injectScript(
          'head-inline',
          `
          window.__VULFORM_CONFIG__ = ${JSON.stringify({
            apiKey: options.apiKey,
            apiUrl: resolvedApiUrl,
            debug: options.debug || false,
          })};
          
          if (typeof window !== 'undefined' && window.__VULFORM_CONFIG__.apiKey) {
            window.__VULFORM_API_KEY__ = window.__VULFORM_CONFIG__.apiKey;
          }
        `
        );

        // Add VulForm styles
        injectScript(
          'head-inline',
          `
          <style>
            .vulform-container {
              max-width: 100%;
            }
            
            .vulform-label {
              display: block;
              font-size: 0.875rem;
              font-weight: 500;
              color: #374151;
              margin-bottom: 0.5rem;
            }
            
            .vulform-input {
              display: block;
              width: 100%;
              padding: 0.75rem;
              border: 1px solid #D1D5DB;
              border-radius: 0.375rem;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
              font-size: 0.875rem;
              line-height: 1.25rem;
              transition: all 0.15s ease;
            }
            
            .vulform-input:focus {
              outline: none;
              border-color: #3B82F6;
              box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
            }
            
            .vulform-input:disabled {
              background-color: #F9FAFB;
              cursor: not-allowed;
            }
            
            .vulform-error-text {
              margin-top: 0.25rem;
              font-size: 0.875rem;
              color: #EF4444;
            }
            
            .vulform-submit-button:disabled {
              background-color: #9CA3AF !important;
              cursor: not-allowed;
            }
            
            .animate-pulse {
              animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
            }
            
            .animate-spin {
              animation: spin 1s linear infinite;
            }
            
            @keyframes pulse {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.5; }
            }
            
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          </style>
        `
        );
      },
    },
  };
}

// Export default integration
export default VulFormIntegration;
